import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Table from "../../../../core/common/dataTable/index";
import { exam } from "../../../../core/data/json/exam";
import dayjs from "dayjs";
import { all_routes } from "../../../router/all_routes";
import { useUserPermissions } from "../../../UserPermissionsContext";
import Cookies from "js-cookie";
import Spin from "antd/es/spin";
import { Toast } from "react-bootstrap";
import { format, isMonday, set, startOfWeek } from "date-fns";
import { Calendar, DateRange } from "react-date-range";
import { ArrowDownOutlined, ArrowUpOutlined } from "@ant-design/icons";
import { ColumnsType } from "antd/es/table/interface";

type Permission = { id: number; name: string };
type Admin = {
  permissions: Array<number>;
  name: string | null;
  id: number;
};
type SortOrder = 'ascend' | 'descend' | null;

interface SortConfig {
  field: string;
  order: SortOrder;
}


const WizklubDailySalesTarget = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  const data = exam;
  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Month is zero-based, so we add 1
  const day = String(today.getDate()).padStart(2, "0");
  const formattedDate = `${month}-${day}-${year}`;
  const defaultValue = dayjs(formattedDate);
  const jwtToken = Cookies.get("authToken");
  const { userPermissions, webApi } = useUserPermissions();
  const [isLoading, setIsLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [permissions, setPermissions] = useState<Permission[]>([]);
  const [admin, setAdmin] = useState<Admin[]>([]);
  const [from, setFrom] = useState();
  const [to, setTo] = useState<number>();
  const [totalCount, setTotalCount] = useState();
  const [toastMessage, setToastMessage] = useState("");
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [searchText, setSearchText] = useState<string>("");
  const [selectedMailId, setSelectedMailId] = useState(null);
  const [showSolidSuccessToast, setshowSolidSuccessToast] = useState(false);
  const handleSolidSuccessToastClose = () => setshowSolidSuccessToast(false);
  const [showSolidDangerToast, setShowSolidDangerToast] = useState(false);
  const handleSolidDangerToastClose = () => setShowSolidDangerToast(false);
  // const [toastMessage, setToastMessage] = useState("");              
  const [showCalendar1, setShowCalendar1] = useState(false);
  const checkPermission = (action: any, subject: any) => {
    return userPermissions.some(
      (ability) => ability.action === action && ability.subject === subject
    );
  };
  const [sortConfigs, setSortConfigs] = useState<SortConfig[]>([]);

  const [selectedDate, setSelectedDate] = useState(() => {
    const savedDate = localStorage.getItem("singleMondayDate1");
    return savedDate ? new Date(savedDate) : new Date(); // default is today
  });


  useEffect(() => {
    if (selectedDate) {
      const formatted = format(selectedDate, "yyyy-MM-dd"); // 👉 Ensures '2025-07-14'
      localStorage.setItem("singleMondayDate1", formatted);
      setShowCalendar1(false);
    } else {
      localStorage.removeItem("singleMondayDate1");
    }
  }, [selectedDate]);

  useEffect(() => {
    if (!checkPermission("view_agentdailysalestarget", "agentdailysalestarget")) {
      Cookies.remove("authToken");
      navigate(routes.crmLandingPage);
    } else {
      fetchData(currentPage, pageSize, searchText, selectedDate);
    }
  }, [userPermissions]);

  const handleApplyClick = () => {
    if (dropdownMenuRef.current) {
      dropdownMenuRef.current.classList.remove("show");
    }
  };

  const getModalContainer = () => {
    const modalElement = document.getElementById("modal-datepicker");
    return modalElement ? modalElement : document.body; // Fallback to document.body if modalElement is null
  };

  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  const fetchGroupsData = async (
    page: number,
    pageSize: number,
    searchText: string,
    week_start_date: any,
    sortConfigs: SortConfig[],
  ) => {
    let apiUrl = `${webApi}/wizklub/agent_wise_daily_sales_targets/?page=${page}&page_size=${pageSize}&search=${searchText}`;
    if (week_start_date) {
      const formattedDate =
        week_start_date instanceof Date
          ? format(week_start_date, "yyyy-MM-dd")
          : format(new Date(week_start_date), "yyyy-MM-dd");

      apiUrl += `&date=${formattedDate}`;
    }
    if (sortConfigs.length > 0) {
      const orderingParams = sortConfigs
        .map(({ field, order }) =>
          order === 'descend' ? `-${field}` : field
        )
        .join(',');
      apiUrl += `&ordering=${orderingParams}`;
    }
    const response = await fetch(
      apiUrl,
      options
    );
    if (!response.ok) {
      const errorData = await response.json();
      if (errorData.code === "token_not_valid") {
        navigate("/login");
      }
      throw new Error(errorData.detail || "Failed to fetch user data");
    }
    return await response.json();

  };

  const fetchPermissionsData = async () => {
    const resposne = await fetch(
      `${webApi}/user/get_permissions_dropdown/`,
      options
    );

    return await resposne.json();
  };

  const fetchData = async (
    page: number,
    pageSize: number,
    searchText: string,
    week_start_date: any,
  ) => {
    setIsLoading(true); // Start loading
    try {
      const [groupsData, permissionsData] = await Promise.all([
        fetchGroupsData(page, pageSize, searchText, week_start_date,sortConfigs),
        fetchPermissionsData(),
      ]);
      setTotalPages(groupsData.total_pages);
      setAdmin(groupsData.results);
      setPermissions(permissionsData.results);
      setTotalCount(groupsData.total_count);
      setFrom(groupsData.from);
      setTo(groupsData.to);
      setTotalCount(groupsData.total_count);
      setToastMessage(groupsData.message || "submitted successfully!");
      setShowSuccessToast(true);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false); // Stop loading
    }
  };

  const handleTableChange = (pagination: any) => {
    const { current, pageSize } = pagination;
    setCurrentPage(current);
    setPageSize(pageSize);
    // fetchData(current, pageSize, searchText); // Fetch new data based on the updated pagination
  };

  const handleSearch = (value: string) => {
    setSearchText(value);
    // fetchData(currentPage, pageSize, value);
  };

  useEffect(() => {
    fetchData(currentPage, pageSize, searchText, selectedDate);
  }, [currentPage, pageSize, searchText, selectedDate,sortConfigs])

  const handleSendMail = async () => {
    if (!selectedMailId) return;

    try {
      const response = await fetch(
        `${webApi}/mailhub/send_agent_weekly_sale_target_email_task/${selectedMailId}/`, options
      );

      if (!response.ok) {
        setToastMessage("Failed to send mail")
        setShowSolidDangerToast(true);
        setTimeout(() => {
          setShowSolidDangerToast(false);
        }, 3000);
      };

      const data = await response.json();
      console.log("Mail sent successfully:", data);
      setToastMessage(data.results);
      setshowSolidSuccessToast(true);
      setTimeout(() => setshowSolidSuccessToast(false), 3000);
      // Optionally show success toast
      // toast.success("Mail sent successfully!");
    } catch (error) {
      console.error("Error sending mail:", error);
      // Optionally show error toast
      // toast.error("Failed to send mail");
    }
  };


  const columns: ColumnsType<any> = [
    {
      title: (<span>
        Agent
        {sortConfigs.some(config => config.field === "agent__username") && (
          <span style={{ marginLeft: 8 }}>
            {sortConfigs.find(config => config.field === "agent__username")?.order === 'ascend' ? (
              <ArrowUpOutlined style={{ color: '#1890ff' }} />
            ) : (
              <ArrowDownOutlined style={{ color: '#1890ff' }} />
            )}
          </span>
        )}
      </span>),
      dataIndex: "agent_username",
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      onHeaderCell: () => ({
        onClick: () => {
          const newSortConfigs = [...sortConfigs];
          const existingSortIndex = newSortConfigs.findIndex(
            (config) => config.field === "agent__username"
          );

          // Cycle through sorting states (ascend → descend → remove)
          if (existingSortIndex >= 0) {
            const currentOrder = newSortConfigs[existingSortIndex].order;
            if (currentOrder === 'ascend') {
              newSortConfigs[existingSortIndex].order = 'descend';
            } else {
              newSortConfigs.splice(existingSortIndex, 1); // Remove if already descending
            }
          } else {
            newSortConfigs.push({ field: "agent__username", order: "ascend" });
          }

          setSortConfigs(newSortConfigs);
        },
      }),
    },
    {
      title: (<span>Date
        {sortConfigs.some(config => config.field === "date") && (
          <span style={{ marginLeft: 8 }}>
            {sortConfigs.find(config => config.field === "date")?.order === 'ascend' ? (
              <ArrowUpOutlined style={{ color: '#1890ff' }} />
            ) : (
              <ArrowDownOutlined style={{ color: '#1890ff' }} />
            )}
          </span>
        )}
      </span>),
      dataIndex: "date",
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      onHeaderCell: () => ({
        onClick: () => {
          const newSortConfigs = [...sortConfigs];
          const existingSortIndex = newSortConfigs.findIndex(
            (config) => config.field === "date"
          );

          // Cycle through sorting states (ascend → descend → remove)
          if (existingSortIndex >= 0) {
            const currentOrder = newSortConfigs[existingSortIndex].order;
            if (currentOrder === 'ascend') {
              newSortConfigs[existingSortIndex].order = 'descend';
            } else {
              newSortConfigs.splice(existingSortIndex, 1); // Remove if already descending
            }
          } else {
            newSortConfigs.push({ field: "date", order: "ascend" });
          }

          setSortConfigs(newSortConfigs);
        },
      }),
    },
    // {
    //   title: (
    //     <span>
    //       Connected Calls
    //       {sortConfigs.some(config => config.field === "connected_calls") && (
    //         <span style={{ marginLeft: 8 }}>
    //           {sortConfigs.find(config => config.field === "connected_calls")?.order === 'ascend' ? (
    //             <ArrowUpOutlined style={{ color: '#1890ff' }} />
    //           ) : (
    //             <ArrowDownOutlined style={{ color: '#1890ff' }} />
    //           )}
    //         </span>
    //       )}
    //     </span>
    //   ),
    //   dataIndex: "connected_calls",
    //   sorter: true,
    //   sortDirections: ['ascend', 'descend'],
    //   onHeaderCell: () => ({
    //     onClick: () => {
    //       const newSortConfigs = [...sortConfigs];
    //       const existingSortIndex = newSortConfigs.findIndex(
    //         (config) => config.field === "connected_calls"
    //       );

    //       // Cycle through sorting states (ascend → descend → remove)
    //       if (existingSortIndex >= 0) {
    //         const currentOrder = newSortConfigs[existingSortIndex].order;
    //         if (currentOrder === 'ascend') {
    //           newSortConfigs[existingSortIndex].order = 'descend';
    //         } else {
    //           newSortConfigs.splice(existingSortIndex, 1); // Remove if already descending
    //         }
    //       } else {
    //         newSortConfigs.push({ field: "connected_calls", order: "ascend" });
    //       }

    //       setSortConfigs(newSortConfigs);
    //     },
    //   }),
    // },
    // {
    //   title: (<span>
    //     Conversation
    //     {sortConfigs.some(config => config.field === "conversion_time") && (
    //       <span style={{ marginLeft: 8 }}>
    //         {sortConfigs.find(config => config.field === "conversion_time")?.order === 'ascend' ? (
    //           <ArrowUpOutlined style={{ color: '#1890ff' }} />
    //         ) : (
    //           <ArrowDownOutlined style={{ color: '#1890ff' }} />
    //         )}
    //       </span>
    //     )}
    //   </span>),
    //   dataIndex: "conversion_time_display",
    //   sorter: true,
    //   sortDirections: ['ascend', 'descend'],
    //   onHeaderCell: () => ({
    //     onClick: () => {
    //       const newSortConfigs = [...sortConfigs];
    //       const existingSortIndex = newSortConfigs.findIndex(
    //         (config) => config.field === "conversion_time"
    //       );

    //       // Cycle through sorting states (ascend → descend → remove)
    //       if (existingSortIndex >= 0) {
    //         const currentOrder = newSortConfigs[existingSortIndex].order;
    //         if (currentOrder === 'ascend') {
    //           newSortConfigs[existingSortIndex].order = 'descend';
    //         } else {
    //           newSortConfigs.splice(existingSortIndex, 1); // Remove if already descending
    //         }
    //       } else {
    //         newSortConfigs.push({ field: "conversion_time", order: "ascend" });
    //       }

    //       setSortConfigs(newSortConfigs);
    //     },
    //   }),
    // },
    {
      title: (<span>
        Target
        {sortConfigs.some(config => config.field === "target_conversion_time") && (
          <span style={{ marginLeft: 8 }}>
            {sortConfigs.find(config => config.field === "target_conversion_time")?.order === 'ascend' ? (
              <ArrowUpOutlined style={{ color: '#1890ff' }} />
            ) : (
              <ArrowDownOutlined style={{ color: '#1890ff' }} />
            )}
          </span>
        )}
      </span>),
      dataIndex: "target",
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      onHeaderCell: () => ({
        onClick: () => {
          const newSortConfigs = [...sortConfigs];
          const existingSortIndex = newSortConfigs.findIndex(
            (config) => config.field === "target_conversion_time"
          );

          // Cycle through sorting states (ascend → descend → remove)
          if (existingSortIndex >= 0) {
            const currentOrder = newSortConfigs[existingSortIndex].order;
            if (currentOrder === 'ascend') {
              newSortConfigs[existingSortIndex].order = 'descend';
            } else {
              newSortConfigs.splice(existingSortIndex, 1); // Remove if already descending
            }
          } else {
            newSortConfigs.push({ field: "target_conversion_time", order: "ascend" });
          }

          setSortConfigs(newSortConfigs);
        },
      }),
    },
    {
      title: (<span>
        Achieved
        {sortConfigs.some(config => config.field === "conversion_efficiency") && (
          <span style={{ marginLeft: 8 }}>
            {sortConfigs.find(config => config.field === "conversion_efficiency")?.order === 'ascend' ? (
              <ArrowUpOutlined style={{ color: '#1890ff' }} />
            ) : (
              <ArrowDownOutlined style={{ color: '#1890ff' }} />
            )}
          </span>
        )}
      </span>),
      dataIndex: "achieved",
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      onHeaderCell: () => ({
        onClick: () => {
          const newSortConfigs = [...sortConfigs];
          const existingSortIndex = newSortConfigs.findIndex(
            (config) => config.field === "conversion_efficiency"
          );

          // Cycle through sorting states (ascend → descend → remove)
          if (existingSortIndex >= 0) {
            const currentOrder = newSortConfigs[existingSortIndex].order;
            if (currentOrder === 'ascend') {
              newSortConfigs[existingSortIndex].order = 'descend';
            } else {
              newSortConfigs.splice(existingSortIndex, 1); // Remove if already descending
            }
          } else {
            newSortConfigs.push({ field: "conversion_efficiency", order: "ascend" });
          }

          setSortConfigs(newSortConfigs);
        },
      }),
    },

    // {
    //   title: "Mail",
    //   dataIndex: "action",
    //   render: (_text: any, record: { agent: any }) => (
    //     <div className="d-flex align-items-center">
    //       {checkPermission("can_send_weekly_sales_performance_mail", "weeklysales") && (
    //         <button
    //           className="btn btn-outline-light bg-white btn-icon d-flex align-items-center justify-content-center rounded-circle p-0 me-3"
    //           data-bs-toggle="modal"
    //           data-bs-target="#mail_confirmation_modal"
    //           onClick={() => setSelectedMailId(record.agent)}
    //         >
    //           <i className="ti ti-mail" />
    //         </button>
    //       )}
    //     </div>
    //   ),
    // },
    {
      title: "Action",
      dataIndex: "action",
      render: (_text: any, record: { id: any }) => (
        <div className="d-flex align-items-center">
          {checkPermission("change_agentdailysalestarget", "agentdailysalestarget") && (
            <Link
              className="btn btn-icon btn-sm btn-soft-info rounded-pill"
              to={routes.EditWizklubDailySalesTaarget}
              state={{ id: record.id }}
            >
              <i className="feather-edit" />
            </Link>
          )}
        </div>
      ),
    },
  ];

  const handleExportClick = () => {
    let url = `${webApi}/exports/export_daily_call_conversation_report/?token=${jwtToken}`;

    // Add orientation only if not 0
    if (selectedDate) {
      const formattedDate =
        selectedDate instanceof Date
          ? format(selectedDate, "yyyy-MM-dd")
          : format(new Date(selectedDate), "yyyy-MM-dd");
      url += `&date=${formattedDate}`;
    }



    window.location.href = url;
  };

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Sales Daily Target</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.wizklubDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Daily Target
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              {/* {checkPermission("add_dailycallconversion", "dailycallconversion") && (
                <Link to={routes.AddWizklubDailySalesTaarget} className="btn btn-primary me-2 mb-2">
                  <i className="ti ti-square-rounded-plus-filled me-2" />
                  Add Target
                </Link>
              )} */}

              {/* {checkPermission("can_export_wizklub_daily_call_conversation_report", "Exports") && (
                <button className="btn btn-primary mb-2" onClick={handleExportClick}>
                  Export
                </button>
              )} */}
            </div>

          </div>
          {/* /Page Header */}
          {/* Guardians List */}
          <div
            className="card "
            style={{
              width: "100%",
              boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
              borderRadius: "10px",
            }}
          >
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Wizklub Daily Target List</h4>
              <div className="d-flex align-items-center flex-wrap">
                <div style={{ position: "relative", marginRight: "8px", marginBottom: "7px" }}>
                  {/* Date Picker Display Box */}
                  <div
                    onClick={() => setShowCalendar1(!showCalendar1)}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "8px 15px",
                      background: "white",
                      borderRadius: "20px",
                      boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                      fontSize: "12px",
                      fontWeight: "bold",
                      color: "#34303D",
                      cursor: "pointer",
                      border: "1px solid #ddd",
                      minWidth: "200px",
                      justifyContent: "center",
                    }}
                  >
                    {selectedDate ? format(selectedDate, "dd MMM yyyy") : "Choose Monday"}
                  </div>

                  {/* Calendar Popup */}
                  {showCalendar1 && (
                    <div
                      style={{
                        position: "absolute",
                        zIndex: 2000,
                        background: "white",
                        borderRadius: "10px",
                        boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                        padding: "5px",
                        left: "-130px",
                        marginTop: "5px",
                      }}
                    >
                      <Calendar
                        date={selectedDate}
                        onChange={(date) => setSelectedDate(date)}
                        color="blue"
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="card-body p-0 py-3">
              {/* <div
                className="serch-global text-right"
                style={{ marginRight: "15px" }}
              >
                <input
                  type="search"
                  className="form-control form-control-sm mb-3 w-auto float-end"
                  value={searchText}
                  placeholder="Search"
                  onChange={(e) => handleSearch(e.target.value)}
                  aria-controls="DataTables_Table_0"
                ></input>
              </div> */}
              {isLoading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    height: "100vh",
                    paddingTop: "20px",
                  }}
                >
                  <Spin /> {/* Display loader while loading */}
                </div>
              ) : (
                <Table
                  columns={columns}
                  dataSource={admin}
                  Selection={false}
                  pagination={{
                    current: currentPage,
                    pageSize: pageSize,
                    locale: { items_per_page: "" },
                    nextIcon: <span>Next</span>,
                    prevIcon: <span>Prev</span>,
                    defaultPageSize: 10,
                    showSizeChanger: true,
                    pageSizeOptions: ["10", "20", "50", "100"],
                    total: totalCount,
                    showTotal: (total: any, range: any[]) =>
                      `${range[0]}-${range[1]} of ${total}`,
                  }}
                  onChange={handleTableChange} // Move this outside of pagination
                  onSearch={handleSearch}
                   searchText={searchText}
                />
              )}
            </div>
          </div>
          {/* /Guardians List */}
        </div>
      </div>
      <div
        className="modal fade"
        id="mail_confirmation_modal"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Confirm Mail</h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <p>Are you sure you want to send the weekly sales performance email?</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-danger"
                data-bs-dismiss="modal"
                style={{ marginRight: "9px" }}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-success"
                data-bs-dismiss="modal"
                onClick={handleSendMail}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      </div>
      <Toast
        show={showSolidSuccessToast}
        onClose={handleSolidSuccessToastClose}
        id="solidSuccessToast"
        className="colored-toast bg-success text-fixed-white"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        style={{
          position: "fixed",
          top: "20px",
          right: "20px",
          zIndex: 1050,
        }}
      >
        <Toast.Body>{toastMessage}</Toast.Body>
      </Toast>
      <Toast
        show={showSolidDangerToast}
        onClose={handleSolidDangerToastClose}
        id="solidDangerToast"
        className="colored-toast bg-danger text-fixed-white"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        style={{
          position: "fixed",
          top: "20px",
          right: "20px",
          zIndex: 1050,
        }}
      >
        <Toast.Body>{toastMessage}</Toast.Body>
      </Toast>
      <>
        {/* Delete Modal */}
        <div className="modal fade" id="delete-modal">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <form>
                <div className="modal-body text-center">
                  <span className="delete-icon">
                    <i className="ti ti-trash-x" />
                  </span>
                  <h4>Confirm Deletion</h4>
                  <p>
                    You want to delete all the marked items, this cant be undone
                    once you delete.
                  </p>
                  <div className="d-flex justify-content-center">
                    <Link
                      to="#"
                      className="btn btn-light me-3"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <Link
                      to="#"
                      data-bs-dismiss="modal"
                      className="btn btn-danger"
                    >
                      Yes, Delete
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Delete Modal */}
      </>
    </div>
  );
};

export default WizklubDailySalesTarget;
